// Libraries
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import localforage from "localforage";

// Reducer
import rootReducer from "store/reducers/Reducer";

localforage.config({
  name: "RivetAI",
});

// Configuration for Redux Persist
const persistConfig = {
  key: "RivetAI", // Key under which the state will be saved in storage
  version: 3, // Version number for the persisted state (increment if structure changes)
  storage: localforage, // The storage mechanism (in this case, it's the default browser indexed db)
  // Persist only minimal client state. Server state should live in TanStack Query.
  whitelist: ["auth"],
};

// Create a persisted reducer using the persistConfig and root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Determine if DevTools should be enabled based on the environment
const useDevTools = process.env.NODE_ENV !== "production";

// Create the Redux store
export const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer
  devTools: useDevTools, // Enable or disable DevTools based on environment
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Ignore certain actions during serialization
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
